import {
  WaitingLine, WaitingLineInput, WaitingLineType, WaitingLineUpdateInput,
} from 'lib/graphql/graphql';
import { DateTime } from 'luxon';
import useEvent from 'providers/event/useEvent';
import { useMemo } from 'react';

function useDefaultWaitingLine(data: Partial<WaitingLine> = {}) {
  const event = useEvent();

  return useMemo<WaitingLineInput | WaitingLineUpdateInput>(() => {
    const {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      __typename,
      activatedTickets,
      status,
      currency,
      ...waitingLineData
    } = data;

    return {
      name: {},
      description: {},
      productDescription: {},
      price: 2,
      quantity: 100,
      callSize: 5,
      limitedQuantity: false,
      maxGroupSize: 1,
      noShowTimeout: 0,
      autoCall: false,
      waitingLineType: WaitingLineType.Free,
      statementDescriptor: '',
      timeSlotStart: DateTime.now().startOf('day').toISO(),
      timeSlotEnd: event.endTime.toISO(),
      timeSlotDuration: 30,
      ticketsPerTimeSlot: 100,
      ...waitingLineData,
    };
  }, [data, event.endTime]);
}

export default useDefaultWaitingLine;
